import { ca } from '@cian/analytics';

export const trackHideOffer = (id: number | undefined, position: number) => {
  ca('eventSite', {
    name: 'oldevent',
    category: 'Click',
    action: 'hide',
    label: 'offer',
    products: [
      {
        id,
        offerType: 'offer',
        position: position + 1,
      },
    ],
  });
};
